import { EventEmitter, Injectable } from '@angular/core';
import { ShepherdService } from 'angular-shepherd';
@Injectable({
  providedIn: 'root',
})
export class UserFlowService {
  constructor(private readonly shepherdService: ShepherdService) {}
  public openMenuEvent = new EventEmitter<any>();
  public openGrantMenuEvent = new EventEmitter<string>();
  startTour() {
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = {
      scrollTo: true,
    };
    this.shepherdService.addSteps([
      {
        id: 'explore_data',
        attachTo: {
          element: '#explore_data',
          on: 'left-end',
        },
        classes: 'header-menu-panel-class align-shephered-panel-left',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => {},
            disabled: true,
            classes: 'shephered-button-prev disable-guide-button',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        cancelIcon: {
          enabled: true,
        },
        title: 'ExploreData',
        text: 'Select your state to see how it ranks in key health and behavioral health factors—and how each county contributes to the overall score.',
        when: {
          show: () => {
            this.openMenuEvent.emit({ menu: 'explore', status: 'open' });
            setTimeout(() => {
              const menuPanel = document.querySelector('.explore-menu-item');
              if (menuPanel) {
                menuPanel.classList.add('shephered-highlight');
              }
            }, 100);
          },
          hide: () => {
            this.openMenuEvent.emit({ menu: 'explore', status: 'close' });
            setTimeout(() => {
              const menuPanel = document.querySelector('.explore-menu-item');
              if (menuPanel) {
                menuPanel.classList.remove('shephered-highlight');
              }
            }, 100);
          },
        },
      },
      {
        id: 'grants',
        attachTo: {
          element: '#grants',
          on: 'left-end',
        },
        classes: 'header-menu-panel-class align-shephered-panel-left',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => {
              this.shepherdService.back();
            },
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        cancelIcon: {
          enabled: true,
        },
        title: 'Grants',
        text: 'Filter grants by location and interest to find the best match quickly.',
        when: {
          show: () => {
            this.openMenuEvent.emit({ menu: 'grant', status: 'open' });
            setTimeout(() => {
              const menuPanel = document.querySelector('.grant-menu-item');
              if (menuPanel) {
                menuPanel.classList.add('shephered-target');
              }
            }, 100);
          },
          hide: () => {
            this.openMenuEvent.emit({ menu: 'grant', status: 'close' });
            setTimeout(() => {
              const menuPanel = document.querySelector('.grant-menu-item');
              if (menuPanel) {
                menuPanel.classList.remove('shephered-highlight');
              }
            }, 100);
          },
        },
      },
      {
        id: 'impact',
        attachTo: {
          element: '#impact',
          on: 'left-end',
        },
        classes: 'header-menu-panel-class align-shephered-panel-left',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => {
              this.shepherdService.back();
            },
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        cancelIcon: {
          enabled: true,
        },
        title: 'Impact.AI',
        text: 'Use the Knowledge Hub to add, edit, or delete datasets based on your selected domain.',
        when: {
          show: () => {
            this.openMenuEvent.emit({ menu: 'impact', status: 'open' });
            setTimeout(() => {
              const menuPanel = document.querySelector('.grant-menu-item');
              if (menuPanel) {
                menuPanel.classList.add('shephered-highlight');
              }
            }, 100);
          },
          hide: () => {
            this.openMenuEvent.emit({ menu: 'impact', status: 'close' });
            setTimeout(() => {
              const menuPanel = document.querySelector('.grant-menu-item');
              if (menuPanel) {
                menuPanel.classList.remove('shephered-highlight');
              }
            }, 100);
          },
        },
      },
      {
        id: 'notification',
        attachTo: {
          element: '#notification_icon',
          on: 'left',
        },
        classes: 'mt-5',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        cancelIcon: {
          enabled: true,
        },
        title: 'Notification',
        text: 'Check the notification menu regularly to stay updated on important activity like shared chats, dataset creations.',
      },
      {
        id: 'user',
        attachTo: {
          element: '#user-icon',
          on: 'left',
        },
        classes: 'mt-5',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              const chatButton = document.getElementById('chatbot_icon');
              chatButton?.click();
              setTimeout(() => {
                this.shepherdService.next();
              });
            },
            classes: 'shephered-button-next',
          },
        ],
        cancelIcon: {
          enabled: true,
        },
        title: 'My Account',
        text: 'Use My Account to view key updates, access the Activity Center, and explore multiple dashboards — all in one place to keep you informed and in control.',
      },
      {
        id: 'ey_impact_ai',
        attachTo: {
          element: '#canvas_chat_container',
          on: 'left-end',
        },
        classes: 'align-shephered-panel-left',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg""> Prev`,
            action: () => {
              const chatButton = document.getElementById('chatbot_icon');
              chatButton?.click();
              setTimeout(() => {
                this.shepherdService.back();
              });
            },
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        cancelIcon: {
          enabled: true,
        },
        title: 'EY Impact.AI ',
        text: 'Impact.AI helps you streamline your workflow — chat with AI, generate documents, explore grant-related insights, and get instant answers from the Knowledge Hub — all in one place.',
      },
      {
        id: 'expand-icon',
        attachTo: {
          element: '#expand_icon',
          on: 'left',
        },
        classes: 'align-shephered-panel-left',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg""> Prev`,
            action: () => {
              this.shepherdService.back();
            },
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              const expandButton = document.getElementById('expand_icon');
              expandButton?.click();
              setTimeout(() => {
                this.shepherdService.next();
              });
            },
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Expand',
        text: 'Click to expand the chat to full screen for a better view — and don’t forget to check the complete user guide for helpful tips on getting the most out of your chat experience!',
      },
      {
        id: 'knowledgeHub',
        attachTo: {
          element: '#knowledgeHub',
          on: 'top',
        },
        classes: 'impact-tour-card',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => {},
            disabled: true,
            classes: 'shephered-button-prev disable-guide-button',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        cancelIcon: {
          enabled: true,
        },
        title: 'Knowledge Hub',
        text: [
          `<span>Use the Knowledge Hub to chat with AI and get instant answers.</span>
           <a href="#">Click here to see a sample</a>`,
        ],
      },
      {
        id: 'dataAnalytics',
        attachTo: {
          element: '#dataAnalytics',
          on: 'top',
        },
        classes: 'impact-tour-card',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Data Analytics',
        text: `<span>Use the Data Analytics to chat with AI and get instant charts or graphs etc.</span><a href="#">Click here to see a sample</a>`,
      },
      {
        id: 'documentGeneration',
        attachTo: {
          element: '#documentGeneration',
          on: 'top',
        },
        classes: 'impact-tour-card',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Document Generation',
        text: 'Use the Document Generation to chat with AI and Generate Document like NOFO etc.<a href="#">Click here to see a sample</a>',
      },
      {
        id: 'impact_textbox',
        attachTo: {
          element: '#impact_textbox',
          on: 'top',
        },
        classes: 'impact-tour-card',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Need help? Just ask!',
        text: "Type your question in simple language — whether it's about reports, insights, tools, or policies — and EYImpact.AI will guide you instantly.",
      },
      {
        id: 'newchat_icon',
        attachTo: {
          element: '#newchat_icon',
          on: 'top-end',
        },
        classes: 'ms-4',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'New Chat',
        text: 'Click the New Chat button to explore a new topic — no need to worry about previous conversation history.',
      },
      {
        id: 'attachfile_icon',
        attachTo: {
          element: '#attachfile_icon',
          on: 'top-end',
        },
        classes: 'panel-text-box-icons',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Attach File',
        text: 'Click the Attach File icon to upload files like PDFs, images, or spreadsheets — and get instant insights, summaries, or answers based on your content.',
      },
      {
        id: 'send_icon',
        attachTo: {
          element: '#send_icon',
          on: 'top-end',
        },
        classes: 'panel-text-box-icons',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => this.shepherdService.next(),
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Send',
        text: 'Click the Send button after typing your question or command to get an instant response from EYImpact.AI',
      },
      {
        id: 'sidebar_icon',
        attachTo: {
          element: '#sidebar_icon',
          on: 'bottom-end',
        },
        classes: 'ms-4',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              const sidebarButton = document.getElementById('sidebar_icon');
              sidebarButton?.click();
              setTimeout(() => {
                this.shepherdService.next();
              });
            },
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Sidebar',
        text: 'Use the Sidebar to access recent chats, saved responses, and key features — all in one place.',
      },
      {
        id: 'bookmark_icon',
        attachTo: {
          element: '#bookmark_icon',
          on: 'bottom-end',
        },
        classes: 'mt-1',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => {
              const sidebarButton = document.getElementById('sidebar_icon');
              sidebarButton?.click();
              setTimeout(() => {
                this.shepherdService.back();
              });
            },
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Bookmark Chat',
        text: 'Click the Bookmarked Chat icon to quickly access your saved or important conversations anytime.',
      },
      {
        id: 'shared-chat-icon',
        attachTo: {
          element: '#shared_chat_icon',
          on: 'bottom-end',
        },
        classes: 'mt-1',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Shared Chat',
        text: 'Click the Shared Chat button to view conversations shared with you or to share insights with your team.',
      },
      {
        id: 'search-chat-icon',
        attachTo: {
          element: '#search_chat_icon',
          on: 'bottom-end',
        },
        classes: 'mt-1',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Search Chat',
        text: 'Use the Search Chat bar in your chat history to quickly locate past conversations,or topics. ',
      },
      {
        id: 'drawer_close_icon',
        attachTo: {
          element: '#drawer_close_icon',
          on: 'bottom-end',
        },
        classes: 'mt-1',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Close',
        text: 'Click the Close Sidebar button to hide the sidebar and focus fully on your current chat.',
      },
      {
        id: 'new_chat_name',
        attachTo: {
          element: '#new_chat_name',
          on: 'bottom',
        },
        classes: 'mt-1',
        buttons: [
          {
            text: `<img src="../../../assets/icons/svg/arrow-left-white.svg"> Prev`,
            action: () => this.shepherdService.back(),
            classes: 'shephered-button-prev',
          },
          {
            text: 'Next <img src="../../../assets/icons/svg/right-white-arrow.svg">',
            action: () => {
              this.shepherdService.next();
            },
            classes: 'shephered-button-next',
          },
        ],
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
        title: 'Chat Name',
        text: "Each conversation shows a Chat Name so you can quickly identify and revisit topics you've discussed.",
      },
    ]);
    this.shepherdService.start();
  }
}
